import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { DialogUserInterviewComponent } from "../../../../dialogs/dialog-user-interview/dialog-user-interview";

const IGNORE_IDENTIFIER = "ignoreUserInterview";

@Component({
  selector: "user-interview-banner",
  templateUrl: "user-interview-banner.html",
  styleUrls: ["user-interview-banner.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class UserInterviewBanner {
  private readonly dialog = inject(MatDialog);

  protected readonly visible = signal(isLongAgo(localStorage.getItem(IGNORE_IDENTIFIER)));

  protected dismiss() {
    localStorage.setItem(IGNORE_IDENTIFIER, new Date(Date.now()).toISOString());
    this.visible.set(false);
  }

  protected openModal() {
    const ref = this.dialog.open(DialogUserInterviewComponent);
    ref.afterClosed().subscribe((submitted: boolean) => {
      if (submitted) {
        this.dismiss();
      }
    });
  }
}

const isLongAgo = (date: string | null): boolean => {
  if (!date) return true;

  const numMonths = 6;
  const pastDate = new Date();
  pastDate.setMonth(pastDate.getMonth() - numMonths);

  const currDate = new Date(date);
  return currDate < pastDate;
};
